// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e0d393bf","513":"0836f402","703":"d8be8d0b","787":"f8d73420"}[chunkId] + ".chunk.js";
};